module.exports = __webpack_public_path__ + "media/combat-fail.f73de150.mp3";